import { Component, OnInit,EventEmitter, Output, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DomiciliacionCtService } from 'src/app/services/domiciliacion-ct/domiciliacion-ct.service';

@Component({
  selector: 'app-data-profile',
  templateUrl: './data-profile.component.html',
  styleUrls: ['./data-profile.component.css']
})
export class DataProfileComponent implements OnInit {
  section_transactions: any = [];
  @Input() code_person: any;
  @Input() person: any;
  @Input() estatus_approve: any;


  @Output() changeView = new EventEmitter<any>();
  @Output() resetStatus = new EventEmitter<any>();

  sections_status:any;
  loadPerson_Address:any;
  personAddress:any;
  customer:any;
  accounts:any;
  supUse: any;
  
  // 🆕 MULTI-PRODUCTO: Propiedades para agrupación
  groupedAccounts: any = {};
  showGrouped: boolean = true;
  products: any[] = []; // Se cargarán dinámicamente

  constructor(
     private _user: UserService,
     private _common: CommonService,
     public _auth: AuthService,
     private domiciliacionCt: DomiciliacionCtService

    ) { }

  /** Estado de las cuentas frente a CrediTotal (etiquetas); si no carga, no se muestran. */
  cuentasCt: any[] = [];

  cuentaCt(item: any, product?: string): any {
    return this.domiciliacionCt.buscarCuenta(this.cuentasCt, { id: item?._id, bank: item?.bank, product: product || item?.product_type || 'CREDIT' });
  }

  ngOnInit(): void {
    this.domiciliacionCt.getCuentasCliente(this.code_person).then(c => (this.cuentasCt = c)).catch(() => (this.cuentasCt = []));
    this.loadActiveProducts(); // 🆕 Cargar productos activos
    this._auth.auth$.subscribe((rep: any) => {
      let sessionUser = rep ? this._auth.sessionUser : null;

      if (
        sessionUser?.username == 'juan@hazling.com' ||
        sessionUser?.username == 'diribarren' ||
        sessionUser?.username == 'asarkis@totalmundo.com' ||
        sessionUser?.username == 'jesuli.montenegro@hazling.com' ||
        sessionUser?.username == 'nathalyaespisona@totalmundo.com' ||
        sessionUser?.username == 'agregorio@totalmundo.com'
      ) {
        this.supUse = true;
      }
    });

    this.getSection_transaction_by_person();
    this.getPerson_Address();
    this.getCustomer();
    this.getAccounts();

  }



getCustomer = async () =>  {

  try {
   // this.loadForm = true;

     let resp =  await this._common.getcustomer({ code_person:this.code_person});

     this.customer = resp.resp;
  } catch (error) {
    console.log(error);

  }

}

  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;


  }


  getContact(item: any) {
    if (!(item?.constacts?.length > 0))
      return "";

    // Buscar el teléfono celular por código
    const phoneCell = item?.constacts?.find((c:any) => c?.type_contact?.code === 'PHONE_CELL');
    
    return phoneCell?.contact || "";


  }

  getPhoneCellHasWhatsapp(item: any) {
    if (!(item?.constacts?.length > 0))
      return false;

    // Buscar el teléfono celular por código
    const phoneCell = item?.constacts?.find((c:any) => c?.type_contact?.code === 'PHONE_CELL');
    
    return phoneCell?.have_whatsapp || false;
  }

  getContact2(item: any) {
    if (!(item?.constacts?.length > 0))
      return "";

    // Buscar el teléfono adicional por código
    const additionalPhone = item?.constacts?.find((c:any) => c?.type_contact?.code === 'ADDITIONAL_PHONE');
    
    return additionalPhone?.contact || "";


  }



  getEmailContact(item: any) {
        if (!(item?.constacts?.length > 0))
          return "";

        // Buscar el email por código
        const email = item?.constacts?.find((c:any) => c?.type_contact?.code === 'EMAIL');
        
        return email?.contact || "";


      }


getPerson_Address = async () =>  {


  try{
    this.loadPerson_Address= true;
  let resp =  await this._common.getPerson_Address({code_person:this.code_person})

  this.personAddress  = resp?.resp;
  this.loadPerson_Address= false;

  } catch (error) {
    console.log(error);
    this.loadPerson_Address= false;

  }

}



getSection_transaction_by_person = async (buro:any = true) => {

  this.sections_status = {};

   try {

   const resp = await this._user.getSection_transaction_by_person({ code: this.code_person,type:'ONBOARDING_APK' });

   const result = resp.resp;
   let temp: any = {};

   if (result?.section_transactions?.length > 0) {

        result?.section_transactions.map((obj: any) => {

       temp[obj?.section_transaction?.code] = obj;

      this.sections_status[obj?.section_transaction?.code] = obj?.condition;

       return obj;

     });

   }

 } catch (error) {

   console.log(error);

 }
 }

  getSectionTransactions = async () => {

    let filter ={type:'DATA_CLIENT'}
    const resp = await this._user.getSectionTransactions(filter);
    this.section_transactions = resp.resp;

  }

  setChange(View:any){
    this.changeView.emit(View);

   }




getAccounts = async () =>  {
  try{
    this.loadPerson_Address= true;
    
    // 🆕 MULTI-PRODUCTO: Usar endpoint agrupado
    if (this.showGrouped) {
      const resp = await this._user.getPaymentMethodsGrouped({
        code_person: this.code_person,
      });
      
      if (resp?.success) {
        this.groupedAccounts = resp.payment_methods_by_product || {};
        console.log('✅ [data-profile] Cuentas agrupadas:', this.groupedAccounts);
        
        // 🔧 FIX: Consolidar con domiciliación legacy de CREDIT
        // El endpoint getPaymentMethodsGrouped NO incluye payment methods legacy
        // que solo están en person.direct_debit_afiliation sin PMC asociado
        await this.consolidateWithLegacyAfiliation();
      }
    } else {
      // Fallback: endpoint original
      let resp = await this._common.getPayment_method({code_person:this.code_person});
      this.accounts = resp?.resp;
    }
    
    this.loadPerson_Address= false;

  } catch (error) {
    console.log(error);
    this.loadPerson_Address= false;
  }
}

// 🔧 FIX: Consolidar con afiliación legacy de CREDIT
private async consolidateWithLegacyAfiliation() {
  try {
    // Obtener resumen de domiciliación (incluye legacy + array nuevo)
    const summaryResp = await this._user.getDirectDebitSummary({
      code_person: this.code_person
    });
    
    // El backend retorna 'direct_debit_summary', no 'summary'
    const summary = summaryResp?.direct_debit_summary || summaryResp?.summary;
    
    if (summaryResp?.success && summary) {
      console.log('📊 [data-profile] Resumen de domiciliación:', summary);
      
      // Si hay CREDIT legacy, verificar si ya está en groupedAccounts
      if (summary.CREDIT && summary.CREDIT.has_afiliation) {
        
        // Verificar si ya existe una domiciliación CREDIT activa en groupedAccounts
        const hasCreditDomiciliation = this.groupedAccounts.CREDIT?.some(
          (item: any) => item?.bank?.direct_debit_active && item?.direct_debit
        );
        
        if (!hasCreditDomiciliation) {
          console.log('🔧 [data-profile] Agregando domiciliación legacy de CREDIT');
          console.log('   Bank:', summary.CREDIT.bank);
          console.log('   Status:', summary.CREDIT.afiliation_status);
          console.log('   Automatic:', summary.CREDIT.automatic);
          
          // Crear entrada virtual para mostrar la domiciliación legacy
          if (!this.groupedAccounts.CREDIT) {
            this.groupedAccounts.CREDIT = [];
          }
          
          // Agregar info de domiciliación legacy
          this.groupedAccounts.CREDIT.push({
            _id: 'legacy',
            product_type: 'CREDIT',
            bank: {
              name: summary.CREDIT.bank,
              direct_debit_active: true
            },
            direct_debit: true,
            direct_debit_default: true,
            afiliation: {
              status: summary.CREDIT.afiliation_status
            },
            is_legacy: true, // Flag para identificar que es legacy
            automatic: summary.CREDIT.automatic
          });
          
          console.log('✅ [data-profile] Domiciliación legacy agregada. Total CREDIT:', this.groupedAccounts.CREDIT.length);
        } else {
          console.log('ℹ️ [data-profile] Ya existe domiciliación CREDIT en groupedAccounts, no se agrega legacy');
        }
      }
    }
  } catch (error) {
    console.error('⚠️ [data-profile] Error consolidando con legacy:', error);
    // No bloquear el flujo si falla
  }
}

  // 🆕 MULTI-PRODUCTO: Cargar productos activos del sistema
  async loadActiveProducts() {
    try {
      const response: any = await this._user.getAllCodesProduct();
      if (response?.success && response?.codes_product) {
        this.products = response.codes_product.filter((p: any) => p.status === 'ACTIVE');
        console.log('📦 [data-profile] Productos activos cargados:', this.products);
      }
    } catch (error) {
      console.error('❌ [data-profile] Error cargando productos:', error);
      // Fallback a productos por defecto si falla la carga
      this.products = [
        { code: 'CREDIT', name: 'Crédito' },
        { code: 'SEGUROS_MERCANTIL', name: 'Seguros Mercantil' },
        { code: 'RECARGAS', name: 'Recargas' }
      ];
    }
  }

  // 🆕 MULTI-PRODUCTO: Métodos helper
  getProductKeys = (): string[] => {
    return Object.keys(this.groupedAccounts);
  }

  getProductName = (productCode: string): string => {
    const product = this.products.find(p => p.code === productCode);
    return product ? product.name : productCode;
  }

  hasNonDirectDebit = (productCode: string): boolean => {
    const accounts = this.groupedAccounts[productCode] || [];
    return accounts.some((item: any) => !item?.bank?.direct_debit_active || !item?.direct_debit);
  }

}
